import actions from "./actions";

const { FETCH_DEPARTMENT, FETCH_DEPARTMENTS, RESET_DEPARTMENT } = actions;

const initState = {
    departments: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    department: {
        _id: null,
        name: "",
        headOfDept: null,
        classHods: [], // Stores [{ session: {}, class: {}, hods: [] }]
        description: "",
        status: "active"
    }
};

const DepartmentReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_DEPARTMENTS:
            return {
                ...state,
                departments: {
                    ...initState.departments,
                    ...data,
                    data: Array.isArray(data?.data) ? data.data : []
                }
            };

        case RESET_DEPARTMENT:
            return {
                ...state,
                department: { ...initState.department }
            };

        case FETCH_DEPARTMENT:
            return {
                ...state,
                department: {
                    ...initState.department,
                    ...data,
                    // Ensures classHods is always an array containing { session, class, hods }
                    classHods: Array.isArray(data?.classHods) ? data.classHods : []
                }
            };

        default:
            return state;
    }
};

export default DepartmentReducer;